import { render, staticRenderFns } from "./eum-legal.vue?vue&type=template&id=8c6e296c&lang=html&"
import script from "./eum-legal.vue?vue&type=script&lang=js&"
export * from "./eum-legal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports